import { Route } from '@angular/router';
import {
  appLayoutGuard,
  authLayoutGuard
} from '@dx-web/modules/shared/data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@dx-web/modules/shared/layouts').then((_) => _.appLayoutRoutes),
    canActivateChild: [appLayoutGuard]
  },
  {
    path: '',
    loadChildren: () =>
      import('@dx-web/modules/shared/layouts').then((_) => _.authLayoutRoutes),
    canActivateChild: [authLayoutGuard]
  }
];
